import { render, staticRenderFns } from "./myzone.vue?vue&type=template&id=73d2640b&"
import script from "./myzone.vue?vue&type=script&lang=js&"
export * from "./myzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports